import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/13ea2bc4aeaef4d7b721935d95db39ce.jpg"
                alt="Custom Clothiers showroom"
                className="w-full h-[600px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>

            {/* Floating Stats Card */}
            <div className="absolute -bottom-8 -right-8 bg-white rounded-2xl shadow-2xl p-6 max-w-xs">
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 bg-[#C4A962]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-award-line text-[#C4A962] text-3xl"></i>
                </div>
                <div>
                  <div className="text-3xl font-bold text-gray-900">55+</div>
                  <div className="text-sm text-gray-600">Years of Excellence</div>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <div className="inline-block bg-[#C4A962]/10 rounded-full px-4 py-2 mb-6">
              <span className="text-[#C4A962] font-semibold text-sm">About Custom Clothiers</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Wellesley's Premier Custom Tailoring Experience
            </h2>

            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              For over 55 years, Custom Clothiers has been the trusted choice for discerning gentlemen seeking the finest bespoke tailoring in Massachusetts. Our Wellesley showroom showcases thousands of premium fabrics from world-renowned European mills.
            </p>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Our master tailors bring decades of experience and Old World craftsmanship to every garment. Whether you need a custom suit for a special occasion or a complete wardrobe refresh, we deliver exceptional quality and personalized service.
            </p>

            {/* Key Points */}
            <div className="space-y-4 mb-8">
              <div className="flex items-start">
                <div className="w-6 h-6 bg-[#C4A962] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="ml-4 text-gray-700">
                  <strong>Expert Craftsmanship:</strong> Bespoke tailoring with 30+ precise measurements
                </p>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 bg-[#C4A962] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="ml-4 text-gray-700">
                  <strong>Premium Materials:</strong> 5000+ fabrics from Italy, England, and beyond
                </p>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 bg-[#C4A962] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="ml-4 text-gray-700">
                  <strong>Convenient Service:</strong> We make house and office calls
                </p>
              </div>
            </div>

            {/* CTA Button */}
            <Link
              to="/about"
              className="inline-flex items-center bg-[#C4A962] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#B39952] transition-colors whitespace-nowrap"
            >
              Learn More About Us
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;